<div
    class="relative-wrapper preview container-width"
    *ngIf="shouldShowAddPanelForm(); else dashboardPage"
>
    <app-dashboard-preview
        (onSelectionConfirmed)="handleAddPanelConfirm($event)"
        (onClose)="handleOverlayClose()"
        *ngIf="shouldShowAddPanelForm()"
    ></app-dashboard-preview>
</div>
<ng-template #dashboardPage>
    <div
        class="relative-wrapper container-width"
        *ngIf="dashboard; else loadingSpinner"
    >
        <div class="page-flex" *ngIf="!shouldShowAddPanelForm()">
            <div style="margin-bottom: 10px">
                <span data-cy="dashboard-vessel-name" class="title light"
                    >{{ vesselName }}
                </span>
                <span class="title bold highlighted-text">{{ roleName }}</span>
            </div>
            <div class="dashboard-container">
                <app-dashboard-panel
                    data-cy="dashboard-container"
                    *ngFor="let panel of panels; index as i"
                    [panelParameters]="panel"
                    (onDeleteClicked)="handleDeleteClicked(i)"
                    (onAddPanelClicked)="handleAddPanelClicked(i)"
                ></app-dashboard-panel>
            </div>
        </div>

        <app-confirmation-window
            #confirmOverlay
            [mainLabel]="'dashboard.prompt.delete-panel.prompt' | translate"
            [confirmLabel]="
                'dashboard.prompt.delete-panel.confirm-button' | translate
            "
            [cancelLabel]="
                'dashboard.prompt.delete-panel.cancel-button' | translate
            "
        ></app-confirmation-window>
    </div>
</ng-template>

<ng-template #loadingSpinner>
    <div class="loading-spinner-container">
        {{ "general.notification.retreiving-data" | translate }}
        <app-loading-spinner
            style="height: 200px; width: 200px"
        ></app-loading-spinner>
    </div>
</ng-template>
